import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GoodFaithCheckbox from '../../../formFields/GoodFaithCheckbox';
import OwnerOrRepresentativeCheckbox from '../../../formFields/OwnerOrRepresentativeCheckbox';
import AccurateInformationCheckbox from '../../../formFields/AccurateInformationCheckbox';
import AcceptsLiabilityCheckbox from '../../../formFields/AcceptsLiabilityCheckbox';
import UnderstandsNotificationForwardingCheckbox from '../../../formFields/UnderstandsNotificationForwardingCheckbox';
import AcceptsPossibleAccountTerminationCheckbox from '../../../formFields/AcceptsPossibleAccountTerminationCheckbox';

interface Props {}

const CopyrightHolderCheckboxes: FC<Props> = () => {
  const { t } = useTranslation('contact');
  return (
    <>
      <OwnerOrRepresentativeCheckbox required />
      <GoodFaithCheckbox
        label={t(
          'contact:dmcaForm.legalBlock.holderClaim.goodFaithCheckbox.label'
        )}
        required
      />
      <AccurateInformationCheckbox
        label={t(
          'contact:dmcaForm.legalBlock.holderClaim.accurateInformationCheckbox.label'
        )}
        required
      />

      <AcceptsLiabilityCheckbox required />
      <UnderstandsNotificationForwardingCheckbox
        label={t(
          'contact:dmcaForm.legalBlock.holderClaim.understandsNotificationForwardingCheckbox.label'
        )}
        required
      />
      <AcceptsPossibleAccountTerminationCheckbox
        label={t(
          'contact:dmcaForm.legalBlock.holderClaim.acceptsPossibleAccountTermination.label'
        )}
        required
      />
    </>
  );
};

CopyrightHolderCheckboxes.displayName = 'CopyrightHolderCheckboxes';

export default CopyrightHolderCheckboxes;
